export default {
  OK: "Está bien,",
  ok: "Está bien",
  loginFailed: "Error de inicio de sesión, inténtelo de nuevo.",
  requestFailed: "Solicitud fallida, verifique su conexión a Internet.",
  invalidLogin: "Nombre de usuario o contraseña no válidos.",
  thisFunctionExists: "Esta función ya existe.",
  thisFunctionNotAllowDelete: "Esta función no permite eliminar.",
  thisFunctionNotExists: "Esta función no existe.",
  targetFunctionIdRequired: "Se requiere el ID de función de destino.",
  thisPageExists: "Esta página ya existe.",
  thisPageNotAllowDelete: "Esta página no se puede borrar.",
  thisRoleExists: "Este rol ya existe.",
  thisRoleNotAllowDelete: "Este rol no se puede eliminar.",
  targetRoleIdRequired: "Se requiere el ID de rol de destino.",
  invalidParameter: "Parámetro no válido.",
  systemError: "El sistema no puede procesar su solicitud.",
  spErrorMessage: "Error de mensaje SP (depende de qué error).",
  actionbyRequired: "Se requiere el usuario actual.",
  sessionTokenRequired: "Se requiere un token de sesión.",
  functionIdRequired: "Se requiere ID de función.",
  functionNameRequired: "El nombre de la función es obligatorio.",
  newFunctionNameRequired: "El nombre de la función es obligatorio.",
  pageIdRequired: "Se requiere ID de página.",
  newPageIdRequired: "Se requiere ID de página.",
  newPageNameRequired: "El nombre de la página es obligatorio.",
  targetPageIdRequired: "Se requiere el ID de página de destino.",
  passwordRequired: "Se requiere contraseña.",
  userNameRequired: "Se requiere nombre completo.",
  passwordValidation: "La contraseña debe tener entre 6 y 20 caracteres y una combinación de número(s) y letra(s).",
  pageNumRequired: "Se requiere el número de página.",
  pageSizeRequired: "Se requiere el tamaño de página.",
  roleIdRequired: "Se requiere ID de rol",
  oldPasswordRequired: "Se requiere la contraseña actual.",
  userStatusRequired: "Se requiere el estado del usuario.",
  newRoleIdRequired: "Se requiere ID de rol.",
  newRoleNameRequired: "Se requiere el nombre del rol.",
  startDateIsGteEndDate: "La fecha de inicio es mayor que la fecha de finalización.",
  thisRoleNotExists: "Este rol no existe.",
  thisPageNotExists: "Esta página no existe.",
  thisUserExists: "Este usuario ya existe.",
  thisUserNotExists: "Este usuario no existe.",
  thisUserBlackListed: "Tu cuenta ha sido suspendida.",
  thisUserInactive: "Tu cuenta ha sido desactivada.",
  thisUserBlocked: "Tu cuenta ha sido bloqueada.",
  thisUserNotActive: "Tu cuenta ha sido desactivada.,",
  InvalidPageFunction: "Función de página no válida.",
  invalidUser: "¡Usuario no válido!",
  invalidToken: "¡Sesión no válida!",
  NoUserAccessRight: "¡Permiso denegado!",
  connection: "Error de conexión",
  profileIdRequired: "Se requiere ID de perfil.",
  packageIdRequired: "Se requiere el ID del paquete.",
  fullNameMinThreeChar: "El nombre completo debe tener al menos 3 caracteres.",
  accountIdMinThreeChar: "El ID de cuenta debe tener al menos 3 caracteres.",
  searchCriteriaRequired: "Se requiere criterio de búsqueda.",
  affiliateIdRequired: "Se requiere ID de afiliado.",
  minDepositRequired: "Se requiere un depósito mínimo.",
  bonusRateRequired: "Se requiere una tasa de bonificación.",
  onlyAllowRejectDeposit: "Solo permitir rechazar el boleto de depósito.",
  senderBankIdRequired: "Se requiere una identificación del banco del remitente.",
  senderBankAccNoRequired: "Banco remitente acc no. es necesario.",
  minFTDAmtNumOnly: "Min. FTD Amt acepta solo números.",
  maxFTDAmtNumOnly: "Max. FTD Amt acepta solo números.",
  crmBasicCriteriaRequired: "Se requiere ID de miembro / Teléfono de contacto / Correo electrónico de contacto / Fecha de registro / Última fecha de inicio de sesión.",
  verifiedDateRangeAllowThreeMonths: "El rango de fechas de registro solo permite seleccionar hasta 3 meses.",
  lastLoginDateRangeAllowThreeMonths: "El rango de fechas del último inicio de sesión solo permite seleccionar hasta 3 meses.",
  depositDateRangeAllowThreeMonths: "El rango de fechas de depósito solo permite seleccionar hasta 3 meses.",
  ftdDateRangeAllowThreeMonths: "El rango de fechas de FTD solo permite seleccionar hasta 3 meses.",
  ltdDateRangeAllowThreeMonths: "El rango de fechas LTD solo permite seleccionar hasta 3 meses.",
  lastLoginDateEarlierThanVerifiedDate: "Última fecha de inicio de sesión anterior a la fecha de registro.",
  depositDateEarlierThanVerifiedDate: "Fecha de depósito anterior a la fecha de registro.",
  ftdDateEarlierThanVerifiedDate: "Fecha de FTD anterior a la fecha de registro.",
  ltdDateEarlierThanVerifiedDate: "Fecha LTD anterior a la fecha de registro.",
  ftdFromRequired: "Se requiere FTD desde la fecha.",
  ftdToRequired: "Se requiere FTD hasta la fecha.",
  ltdFromRequired: "Se requiere LTD a partir de la fecha.",
  ltdToRequired: "Se requiere LTD hasta la fecha.",
  failedToLaunchPaymentGateway: "No se pudo iniciar la pasarela de pago.",
  enTitleRequired: "Se requiere título EN.",
  enBodyRequired: "Se requiere cuerpo EN.",
  enImageUrlRequired: "Se requiere la URL de la imagen EN.",
  enImageUrlDesktopRequired: "Se requiere la URL de la imagen de escritorio EN.",
  enAltRequired: "Se requiere EN Alt.",
  enHrefRequired: "Se requiere EN Href.",
  resubmitTicketRequired: "Es necesario volver a enviar el ticket.",
  withtholdBonusAndAmountGreaterThanZero: "La bonificación de retención y el monto de retención no pueden ser mayores que cero al mismo tiempo.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "El retiro máximo, el retiro múltiple y el monto máximo de retiro no pueden ser mayores que cero al mismo tiempo.",
  serverBusy: "El servidor está ocupado ahora. Por favor, inténtelo de nuevo.",
  isRequired: "Por favor, introduzca un {fname}.",
  isMinValue: "{fname} debe tener un mínimo de {fvalue}.",
  isMaxValue: "{fname} debe ser menor o igual que {fvalue}.",
  isMinLength: "{fname} debe tener al menos {fvalue} caracteres.",
  isMaxLength: "{fname} debe ser menor o igual que los caracteres {fvalue}.",
  isAlpha: "{fname} aceptar solo alfabeto.",
  isAlphaNum: "{fname} solo acepta caracteres alfanuméricos.",
  isNumeric: "{fname} acepta solo números.",
  isEmail: "{fname} acepta solo direcciones de correo electrónico válidas.",
  isIpAddress: "{fname} acepta solo direcciones IPv4 válidas.",
  isSameAs: "{fname} debe ser el mismo que {fname2}.",
  isUrl: "{fname} solo acepta URLs.",
  containAlphaNum: "{fname} debe tener al menos un alfabeto y un número.",
  alphaNumWithSpace: "{fname} solo acepta caracteres alfanuméricos.",
  isDecimal: "{fname} acepta solo números.",
  isInteger: "{fname} acepta solo números enteros.",
  selectOption: "Por favor, seleccione un {fname}",
  notSameAs: "{fname} y {fname2} no pueden ser lo mismo.",
  dateRangeAllowOneMonth: "El rango de fechas solo permite seleccionar hasta 1 mes.",
  dateRangeAllowOneYear: "El rango de fechas solo permite seleccionar hasta 1 año.",
  greaterThanZero: "{fname} debe ser mayor que cero.",
  atLeastOneAuthority: "Debe seleccionar al menos una autoridad.",
  BLOCK: "Tu cuenta ha sido bloqueada.",
  SUSPEND: "Tu cuenta ha sido suspendida.",
  CLOSE: "Su cuenta ha sido cerrada.",
  RESETL: "Tu cuenta ha sido restablecida.",
  atLeastOneProvider: "Debe seleccionar al menos un proveedor.",
  failedToGetResultUrl: "No se pudo obtener la URL del resultado.",
  fileSizeValidation: "Demasiado grande, el tamaño máximo permitido es de 1 mb",
  atLeastOnePaymentOption: "Debe seleccionar al menos una opción de pago.,",
  atLeastOnePaymentGateway: "Debe seleccionar al menos una pasarela de pago.",
  dateRangeAllow31Days: "El rango de fechas solo permite seleccionar hasta 31 días.",
  dateRangeAllow31Months: "El rango de fechas solo permite seleccionar hasta 31 meses.",
  dateRangeAllow31Years: "El rango de fechas solo permite seleccionar hasta 31 años.",
  invalidCategory: "Categoría no válida.",
  noChanges: "Sin cambios.",
  permissionDenied: "Permiso denegado.",
  referralCodeRequired: "Se requiere un código de referencia.",
  providerDescRequired: "Se requiere una descripción del proveedor.",
  marqueeContentRequired: "Se requiere contenido de marquesina.",
  bonusNameRequired: "Se requiere el nombre del bono.",
  baseAmountRequired: "Se requiere el monto base.",
  reviewIdRequired: "Se requiere ID de revisión.",
  surveyIdRequired: "Se requiere ID de encuesta.",
  questionRequired: "Se requiere una pregunta.",
  iframeIdRequired: "Se requiere ID de iframe.",
  bonusAmountRequired: "Se requiere el monto del bono.",
  inboxIdRequired: "Se requiere ID de bandeja de entrada.",
  exchangedAmountRequired: "Se requiere la cantidad intercambiada.",
  baseRateRequired: "Se requiere tarifa base.",
  exchangeRateRequired: "Se requiere tipo de cambio.",
  baseCurrencyRequired: "Se requiere la moneda base.",
  exchangeCurrencyRequired: "Se requiere cambio de moneda.",
  depositTypeRequired: "Se requiere el tipo de depósito.",
  nbRedepositRequired: "Se requiere un nuevo depósito de Nb.",
  bankOwnerRequired: "Se requiere el dueño del banco.",
  autoSenderRequired: "Se requiere remitente automático.",
  isRecommendRequired: "Se recomienda es obligatorio.",
  recipientBankIdRequired: "Se requiere el ID bancario del destinatario.",
  recipientBankAccNoRequired: "Se requiere el número de cuenta bancaria del destinatario.",
  accountBalanceRequired: "Se requiere saldo en la cuenta.",
  incomingAmountThresholdRequired: "Se requiere un umbral de cantidad entrante.",
  incomingFrequencyThresholdRequired: "Se requiere un umbral de frecuencia de entrada.",
  outgoingAmountThresholdRequired: "Se requiere el umbral de monto de salida.",
  outgoingFrequencyThresholdRequired: "Se requiere un umbral de frecuencia de salida.",
  bankAccTypeRequired: "Se requiere el tipo de cuenta bancaria.",
  packageRequired: "Se requiere paquete.",
  rtpRequired: "Se requiere RTP.",
  domainIdRequired: "Se requiere ID de dominio.",
  buyOnBehalfRequired: "Se requiere comprar en nombre.",
  serviceProviderRequired: "Se requiere proveedor de servicios.",
  serverAccountRequired: "Se requiere una cuenta de servidor.",
  nameServerRequired: "Se requiere un servidor de nombres.",
  socialLinkRequired: "Se requiere un vínculo social.",
  newSocialPlatformRequired: "Se requiere una nueva plataforma social.",
  attachmentPathRequired: "Se requiere la ruta de conexión del archivo adjunto.",
  depositMethodRequired: "Se requiere método de depósito.",
  depositDateRequired: "Se requiere la fecha de depósito.",
  refNoRequired: "Se requiere el número de referencia.",
  withdrawalAmountRequired: "Se requiere monto de retiro.",
  targetBankAccNoRequired: "Se requiere el número de cuenta bancaria de destino.",
  targetBankIdRequired: "Se requiere una identificación del banco de destino.",
  jsonRatingRequired: "Se requiere la clasificación JSON.",
  startTimeRequired: "Se requiere hora de inicio.",
  accountIdRequired: "Se requiere ID de cuenta.",
  parentIdRequired: "Se requiere identificación de los padres.",
  amountRequired: "Se requiere cantidad.",
  clientIpRequired: "Se requiere la IP del cliente.",
  auditByRequired: "Se requiere auditoría por.",
  systemTypeRequired: "Se requiere el tipo de sistema.",
  currencyRequired: "Se requiere moneda.",
  ipAddressRequired: "Se requiere una dirección IP.",
  affiliateCodeRequired: "Se requiere código de afiliado.",
  contactPhoneRequired: "Se requiere teléfono de contacto.",
  requestTypeRequired: "El tipo de solicitud es obligatorio.",
  securityDisabledRequired: "Se requiere seguridad deshabilitada.",
  gameCodeRequired: "Se requiere código de juego.",
  seqRequired: "Se requiere secuencia.",
  minLimitRequired: "Se requiere un límite mínimo.",
  maxLimitRequired: "Se requiere un límite máximo.",
  commSportsRequired: "Se requiere una comisión para los deportes.",
  commSlotsRequired: "Se requiere una comisión por las tragamonedas.",
  commLivecasinoRequired: "Se requiere una comisión para el casino en vivo.",
  commCockfightRequired: "Se requiere comisión para pelea de gallos.",
  commOthersRequired: "Se requiere comisión para otros.",
  settingValueRequired: "Es necesario establecer el valor.",
  vipIdRequired: "Se requiere una identificación VIP.",
  carryOverRequired: "Se requiere traslado.",
  campaignIdRequired: "Se requiere ID de campaña.",
  titleRequired: "Se requiere título.",
  bodyRequired: "Se requiere cuerpo.",
  itemOrderRequired: "Se requiere pedido de artículo.",
  imageUrlRequired: "Se requiere la URL de la imagen.",
  bannerIdRequired: "Se requiere ID de banner.",
  directionRequired: "Se requiere dirección.",
  defaultOrderRequired: "Se requiere un pedido predeterminado.",
  altRequired: "Se requiere texto alternativo.",
  hrefRequired: "Se requiere Href.",
  targetWindowRequired: "Se requiere la ventana de destino.",
  loginRequiredRequired: "Se requiere inicio de sesión.",
  activeFromRequired: "Se requiere activo desde.,",
  activeToRequired: "Se requiere activo a.",
  bannerTypeRequired: "Se requiere el tipo de banner.",
  pageNameRequired: "El nombre de la página es obligatorio.",
  remarkRequired: "Se requiere observación.",
  settingKeyRequired: "Se requiere la tecla de configuración.",
  memberListRequired: "Se requiere una lista de miembros.",
  memberIdRequired: "Se requiere identificación de miembro",
  workingMonthRequired: "Se requiere un mes laborable.",
  workingDateRequired: "Se requiere fecha de trabajo.",
  tacRequired: "Se requieren términos y condiciones.",
  paymentModeRequired: "Se requiere el modo de pago.",
  newPasswordRequired: "Se requiere una nueva contraseña.",
  loginIdRequired: "Se requiere ID de inicio de sesión.",
  securityTagRequired: "Se requiere etiqueta de seguridad.",
  securityCodeRequired: "Se requiere código de seguridad.",
  providerCodeRequired: "Se requiere el código del proveedor.",
  startDateRequired: "Se requiere fecha de inicio.",
  endDateRequired: "Se requiere la fecha de finalización.",
  searchIdRequired: "Se requiere ID de búsqueda.",
  authTokenRequired: "Se requiere token de autenticación.",
  newStatusRequired: "Se requiere un nuevo estado.",
  actionRequired: "Es necesario tomar medidas.",
  promotionIdRequired: "Se requiere ID de promoción.",
  promotionNameRequired: "Se requiere el nombre de la promoción.",
  rolloverRequired: "Se requiere rollover.",
  criteriaRequired: "Se requiere criterio.",
  ticketIdRequired: "Se requiere ID de boleto.",
  resultIdRequired: "Se requiere el ID de resultado.",
  bankIdRequired: "Se requiere una identificación bancaria.",
  bankAccNoRequired: "Se requiere número de cuenta bancaria.",
  bankAccHolderRequired: "Se requiere titular de una cuenta bancaria.",
  newBankIdRequired: "Se requiere una nueva identificación bancaria.",
  newBankAccNoRequired: "Se requiere un nuevo número de cuenta bancaria.",
  newBankAccHolderRequired: "Se requiere un nuevo titular de una cuenta bancaria.",
  fullNameRequired: "Se requiere el nombre completo.",
  depositAmountRequired: "Se requiere monto del depósito.",
  gatewayAccRequired: "Se requiere una cuenta de puerta de enlace.",
  labelNameRequired: "Se requiere el nombre de la etiqueta.",
  labelIdRequired: "Se requiere ID de etiqueta.",
  bankTypeRequired: "Se requiere el tipo de banco.",
  amountLimitRequired: "Se requiere un límite de cantidad.",
  currencyRateRequired: "Se requiere el tipo de cambio.",
  urlRequired: "Se requiere URL.",
  cashRequired: "Se requiere dinero en efectivo.",
  csRequired: "Se requiere atención al cliente.",
  vipNameRequired: "Se requiere el nombre VIP.",
  campaignNameRequired: "El nombre de la campaña es obligatorio.",
  transferIdRequired: "Se requiere ID de transferencia.",
  betTimeRequired: "Se requiere tiempo de apuesta.",
  turnoverRequired: "Se requiere rotación.",
  payoutRequired: "Se requiere pago.",
  winloseRequired: "Se requiere ganar/perder.",
  rawMessageRequired: "Se requiere un mensaje sin procesar.",
  authStatusRequired: "Se requiere el estado de autenticación.",
  dateRequired: "Se requiere la fecha.",
  betIdRequired: "Se requiere ID de apuesta.",
  betStatusRequired: "Se requiere el estado de la apuesta.",
  betAmountRequired: "Se requiere el monto de la apuesta.",
  isParlayRequired: "Es necesario parlay.",
  isAddonRequired: "Se requiere un complemento.",
  withholdBonusRequired: "Se requiere un bono de retención.",
  withholdAmountRequired: "Se requiere monto de retención.",
  maxWithdrawAmountRequired: "Se requiere el monto máximo de retiro.",
  betTypeRequired: "Se requiere el tipo de apuesta.",
  maxWithdrawMultipleRequired: "Se requiere un retiro múltiple máximo.",
  socialPlatformRequired: "Se requiere una plataforma social.",
  vipProviderRebateRequired: "Se requiere un reembolso del proveedor VIP.",
  selfRebateRateRequired: "Se requiere una tasa de reembolso automático.",
  downlineRebateRateRequired: "Se requiere una tasa de reembolso de línea descendente.",
  tierIdRequired: "Se requiere ID de nivel.",
  rebateRateRequired: "Se requiere una tasa de reembolso.",
  paymentGatewayRequired: "Se requiere pasarela de pago.",
  rescueIdRequired: "Se requiere identificación de rescate.",
  rescueNameRequired: "Se requiere el nombre del rescate.",
  rescueCycleRequired: "Se requiere ciclo de rescate.",
  minLoseRequired: "Se requiere una pérdida mínima.",
  rescueRateRequired: "Se requiere tasa de rescate.",
  maxPayoutRequired: "Se requiere el pago máximo.",
  payoutMethodRequired: "Se requiere método de pago.",
  targetGroupRequired: "Se requiere el grupo objetivo.",
  maintainDepositRequired: "Se requiere mantener el depósito.",
  maintainTurnoverRequired: "Es necesario mantener la rotación.",
  depositOrTurnoverRequired: "Se requiere depósito o facturación.",
  maintainDepositOrMaintainTurnoverRequired: "Se requiere mantener el depósito o mantener la facturación.",
  vipListRequired: "Se requiere lista VIP.",
  gameNameRequired: "Se requiere el nombre del juego.",
  claimTypeRequired: "Se requiere el tipo de notificación.",
  operatorIdRequired: "Se requiere ID de operador.",
  maxBonusRequired: "Se requiere un bono máximo.",
  endTimeRequired: "Se requiere la hora de finalización.",
  mondayRequired: "El lunes es obligatorio.",
  tuesdayRequired: "El martes es obligatorio.",
  wednesdayRequired: "El miércoles es obligatorio.",
  thursdayRequired: "El jueves es obligatorio.",
  fridayRequired: "El viernes es obligatorio.",
  saturdayRequired: "El sábado es obligatorio.",
  sundayRequired: "El domingo es obligatorio.",
  promotionTypeRequired: "Se requiere el tipo de promoción.",
  claimLimitRequired: "Se requiere un límite de reclamación.",
  bonusRate1Required: "Se requiere la tasa de bonificación 1.",
  bonusRate1To2Required: "Se requiere una tasa de bonificación de 1 a 2.",
  bonusRate1To3Required: "Se requiere una tasa de bonificación de 1 a 3.",
  bonusRate1To4Required: "Se requiere una tasa de bonificación de 1 a 4.",
  bonusRate1To5Required: "Se requiere una tasa de bonificación de 1 a 5.",
  bonusRate1To6Required: "Se requiere una tasa de bonificación de 1 a 6.",
  bonusRate1To7Required: "Se requiere una tasa de bonificación de 1 a 7.",
  externalIdRequired: "Se requiere un ID externo.",
  opsiteRequired: "Se requiere Opsite.",
  opsiteContentRequired: "Se requiere contenido del sitio.",
  opsiteLanguageRequired: "Se requiere el idioma adecuado.",
  opsitePaymentRequired: "Se requiere el pago oportuno.",
  opsiteProviderRequired: "Se requiere un proveedor de Opsite.",
  opsiteProviderGamesRequired: "Se requieren juegos del proveedor Opsite.",
  accountTypeRequired: "Se requiere el tipo de cuenta.",
  domainNameRequired: "Se requiere un nombre de dominio.",
  settledTimeRequired: "Se requiere tiempo establecido.",
  validTurnoverRequired: "Se requiere un volumen de negocios válido.",
  resultTimeRequired: "Se requiere tiempo de resultado.",
  resultStatusRequired: "Se requiere el estado del resultado.",
  secondIdRequired: "Se requiere una segunda identificación.",
  domainListRequired: "Se requiere lista de dominios.",
  domainTypeRequired: "Se requiere el tipo de dominio.",
  moduleRequired: "Se requiere módulo.",
  gameIdRequired: "Se requiere ID de juego.",
  gameDetailRequired: "Se requiere detalle del juego.",
  bonusRate1To8Required: "Se requiere una tasa de bonificación de 1 a 8.",
  bonusRate1To9Required: "Se requiere una tasa de bonificación del 1 al 9.",
  bonusRate1To10Required: "Se requiere una tasa de bonificación del 1 al 10.",
  invalidOrder: "Pedido inválido.",
  bannerNotExists: "El banner no existe.",
  invalidBannerType: "Tipo de banner no válido.",
  pageNameExists: "El nombre de la página existe.",
  pageNotExists: "La página no existe.",
  tacIsValid: "OTP es válido.",
  invalidTac: "OTP no válida.",
  tacExpired: "OTP caducado.",
  tacNotValidate: "OTP no validado.",
  paymentModeNotExists: "El modo de pago no existe.",
  paymentOptionProviderNotExists: "El proveedor de opciones de pago no existe.",
  ipAddressExists: "La dirección IP existe.",
  ticketProcessed: "Ticket procesado.",
  bankAccountNotExists: "La cuenta bancaria no existe.",
  bankAccountInactive: "Cuenta bancaria inactiva.,",
  bankMemberNotExists: "El miembro del banco no existe.",
  bankMemberInactive: "Miembro del banco inactivo.",
  affiliateExists: "El afiliado existe.",
  contactPhoneExists: "Existe teléfono de contacto.",
  affiliateFull: "Afiliado completo.",
  uplineInactive: "Línea ascendente inactiva.",
  applicationProcessed: "Solicitud tramitada.",
  tacValidated: "Términos y condiciones validados.",
  applicationPending: "Solicitud pendiente.",
  favouriteGameExists: "Existe el juego favorito.",
  invalidLimit: "Límite no válido.",
  settingNotSet: "Configuración no configurada.",
  domainNameNotExists: "El nombre de dominio no existe.",
  domainNameFull: "Nombre de dominio completo.",
  domainNameNotAvailable: "Nombre de dominio no disponible.",
  domainNameExists: "El nombre de dominio existe.",
  subAccountNotExists: "La subcuenta no existe.",
  settingNotExists: "La configuración no existe.",
  invalidContactEmail: "Correo electrónico de contacto no válido.",
  accountInactive: "La cuenta está inactiva.",
  campaignNotExists: "La campaña no existe.",
  paymentProviderNotExists: "El proveedor de pagos no existe.",
  profileInactive: "Perfil inactivo.",
  minWithdrawalNotMet: "No se ha cumplido el retiro mínimo.",
  invalidBankId: "ID bancario no válido.",
  bankAccountExists: "La cuenta bancaria existe.",
  bankAccountFull: "Cuenta bancaria llena.",
  bankAccHolderNotSame: "El titular de la cuenta bancaria no es el mismo.",
  exceedMaxWithdrawal: "Supera el retiro máximo.",
  exceedWithdrawalFrequency: "Excede la frecuencia de retiro.",
  invalidPackage: "Paquete no válido.",
  promotionNotAvailable: "Promoción no disponible.",
  ongoingPromotion: "Promoción continua.",
  pendingResultInGame: "Pendiente de resultado en el juego.",
  labelNameExists: "El nombre de la etiqueta existe.",
  labelNotExists: "La etiqueta no existe.",
  invalidFtdMin: "Depósito mínimo no válido por primera vez.",
  invalidFtdMax: "Máximo de depósito por primera vez no válido.",
  ftdMinGtFtdMax: "Depósito mínimo por primera vez mayor que el máximo.",
  vipFull: "VIP lleno.",
  invalidRewardType: "Tipo de recompensa no válido.",
  vipExists: "VIP existe.",
  vipNotExists: "VIP no existe.",
  onlyOneMaxWithdrawSetting: "Solo se permite una configuración de retiro máximo.",
  onlyOneWithholdSetting: "Solo se permite una configuración de retención.",
  campaignExists: "La campaña existe.",
  vipProviderNotExists: "El proveedor VIP no existe.",
  turnoverTierExists: "Existe el nivel de volumen de negocios.",
  turnoverTierFull: "El nivel de facturación supera el nivel máximo.",
  turnoverTierNotExists: "El nivel de facturación no existe.",
  invalidSettingValue: "Valor de configuración no válido.",
  turnoverTierNotSet: "Nivel de facturación no establecido.",
  rebateProcessed: "Reembolso tramitado.",
  invalidActionType: "Tipo de acción no válido.",
  invalidRescueCycle: "Ciclo de rescate no válido.",
  invalidPayoutMethod: "Método de pago no válido.",
  invalidTargetGroup: "Grupo objetivo no válido.",
  rescueExists: "El rescate existe.",
  rescueNotExists: "El rescate no existe.",
  walletExists: "La billetera existe.",
  accountExists: "La cuenta existe.",
  activeFromGtActiveTo: "Activo de mayor que activo hasta.",
  accountNotExists: "El ID de operador no existe.",
  invalidDeposit: "Depósito no válido.",
  invalidTurnover: "Volumen de negocios no válido.",
  providerCodeNotExists: "El código de proveedor no existe.",
  gameNameExists: "El nombre del juego existe.",
  gameNameNotExists: "El nombre del juego no existe.",
  invalidAccountType: "Tipo de cuenta no válido.",
  invalidLoginIdFormat: "Formato de ID de inicio de sesión no válido.",
  invalidReferralCode: "Código de referencia no válido.",
  firstDepositNotMet: "Primer depósito no cumplido.",
  newbieNotMet: "No se cumplen los requisitos para novatos.",
  claimPromoOnlyOnce: "Reclamar promoción solo una vez.",
  promotionRequirementNotMet: "No se ha cumplido el requisito de promoción.",
  withdrawalAmountLteWithholdAmount: "Monto de retiro menor o igual al monto de retención.",
  subAccountInactive: "Subcuenta inactiva.",
  gameNotSupported: "Juego no compatible.",
  startTimeGteEndTime: "Hora de inicio mayor o igual que la hora de finalización.",
  invalidPromotionType: "Tipo de promoción no válido.",
  invalidClaimType: "Tipo de notificación no válido.",
  claimLimitExceeded10: "El límite de reclamaciones superó los 10.",
  verificationFailed: "Error de verificación.",
  claimLimitReached: "Límite de reclamación alcanzado.",
  invalidPromotion: "Promoción inválida.",
  socialPlatformExists: "La plataforma social existe.",
  duplicateReview: "Revisión duplicada.",
  invalidSurveyId: "ID de encuesta no válido.",
  accountNotBlock: "Cuenta no bloqueada.",
  walletNotExists: "La billetera no existe.",
  socialPlatformNotExists: "La plataforma social no existe.",
  socialPlatformInactive: "Plataforma social inactiva.",
  accountSocialExists: "La cuenta social existe.",
  invalidStatus: "Estado no válido.",
  samePassword: "Misma contraseña.",
  invalidPassword: "Nombre de usuario o contraseña no válidos.",
  secondaryAccountExists: "Existe una cuenta secundaria.",
  invalidSecurityCode: "Código de seguridad no válido.",
  accountSocialNotExists: "La cuenta social no existe.",
  providerInactive: "Proveedor inactivo.",
  gameIdExists: "El ID del juego existe.",
  gameIdNotExists: "El ID del juego no existe.",
  parentProviderInactive: "Proveedor principal inactivo.",
  betLimitNotExists: "El límite de apuesta no existe.",
  min3Characters: "Mínimo 3 caracteres.",
  invalidBankAccType: "Tipo de cuenta bancaria no válida.",
  senderBankNotExists: "El banco emisor no existe.",
  recipientBankNotExists: "El banco receptor no existe.",
  affiliateNotExists: "El afiliado no existe.",
  redepositedTicket: "Boleto redepositado.",
  invalidDepositType: "Tipo de depósito no válido.",
  affiliateInactive: "Afiliado inactivo.",
  bonusUnavailable: "Bono no disponible.",
  pendingDeposit: "Depósito pendiente.",
  noOngoingPromotion: "No hay promoción en curso.",
  iframeNotExists: "IFrame no existe.",
  gameMaintenance: "Mantenimiento del juego.",
  labelInactive: "Etiqueta inactiva.",
  invalidDomainType: "Tipo de dominio no válido.,",
  invalidModule: "Módulo no válido.",
  labelFull: "Etiqueta llena.",
  questionExists: "La pregunta existe.",
  questionFull: "Pregunta completa.",
  questionNotExists: "La pregunta no existe.",
  reviewNotExists: "La revisión no existe.",
  invalidDomainGroup: "Grupo de dominio no válido.",
  invalidDateRange: "Intervalo de fechas no válido.",
  ipAddressNotExists: "La dirección IP no existe.",
  marqueeNotExists: "La marquesina no existe.",
  invalidAmount: "Importe no válido.",
  insufficientBalance: "Saldo insuficiente.",
  minLimitLtParent: "Límite mínimo inferior al principal.",
  maxLimitGtParent: "Límite máximo mayor que el principal.",
  startDateGtEndDate: "Fecha de inicio mayor que la fecha de finalización.",
  currencyNotExists: "La moneda no existe.",
  currencyExists: "La moneda existe.",
  noAccumulateWin: "No hay ganancia acumulada.",
  invalidSession: "Sesión no válida.",
  sessionExpired: "Sesión caducada.",
  promotionExists: "La promoción existe.",
  invalidCriteria: "Criterios no válidos.",
  promotionNotExists: "La promoción no existe.",
  ticketNotExists: "El boleto no existe.",
  duplicateDebitRecord: "Duplicado de registro de débito.",
  duplicateCreditRecord: "Duplicado de historial crediticio.",
  debitRecordNotExists: "El registro de débito no existe.",
  minDepositNotMet: "No se ha cumplido el depósito mínimo.",
  duplicateBet: "Apuesta duplicada.",
  invalidProviderCode: "Código de proveedor no válido.",
  resultExists: "El resultado existe.",
  unableSPProcess: "El sistema no puede procesar su solicitud.",
  authRequired: "Se requiere código de autenticación.",
  domainExists: "El dominio ya existe.",
  multiSelectOption: "Por favor, seleccione {fname}",
  invalidDomainFormat: "Formato de dominio no válido",
  noHttpHttps: "No se permite 'https://' ni 'http://'.",
  noReservedSubdomain: "El subdominio reservado no está permitido. Para el uso del enlace de descarga de la aplicación.,",
  operatorInactive: "El operador está inactivo",
  invalidAccountIdFormat: "Formato de ID de cuenta no válido",
  contentIdRequired: "Se requiere ID de menú",
  themeCodeRequired: "Se requiere el código del tema",
  themeNameRequired: "Se requiere el nombre del tema",
  themeColorRequired: "Se requiere el color del tema",
  languageRequired: "El idioma es obligatorio",
  positionRequired: "Se requiere posición",
  themeContentIdRequired: "Se requiere el ID de contenido del tema",
  emailRequired: "Se requiere correo electrónico",
  themeProviderTypeRequired: "Se requiere el tipo de proveedor de temas",
  phoneRequired: "Se requiere teléfono",
  targetTypeRequired: "Se requiere el tipo de destino",
  packageTypeRequired: "Se requiere el tipo de paquete",
  renewTermRequired: "Se requiere renovar el plazo",
  packagePriceRequired: "Se requiere el precio del paquete",
  packageStatusRequired: "Se requiere el estado del paquete",
  sortKeyRequired: "Se requiere clave de ordenación",
  invalidDomainStatus: "Estado de dominio no válido",
  invalidCurrency: "Moneda no válida",
  invalidThemeCode: "Código de tema no válido",
  invalidLanguage: "Idioma no válido",
  invalidPosition: "Posición no válida",
  invalidThemeContent: "Contenido del tema no válido",
  allParamsSameAsCurrent: "No hay cambios",
  invalidThemeColor: "Color de tema no válido",
  invalidCartStatus: "Estado del carrito no válido",
  invalidThemeProviderType: "Tipo de proveedor de temas no válido",
  themeProviderTypeCannotBeUse: "No se puede utilizar el tipo de proveedor de temas",
  invalidUserStatus: "Estado de usuario no válido",
  packageCannotBeRemove: "El paquete no se puede eliminar",
  userStatusIsAlrdSuspend: "El usuario ya está suspendido",
  userStatusIsAlrdBlocked: "El usuario ya está bloqueado",
  userStatusIsAlrdActive: "El usuario ya está activo",
  invalidSortType: "Tipo de ordenación no válido",
  startDateBiggerThanEndDate: "La fecha de inicio es mayor que la fecha de finalización",
  positionCannotBeUse: "No se puede utilizar la posición",
  funcAddContentFailed: "No se pudo agregar contenido",
  funcDeleteContentFailed: "No se pudo eliminar el contenido",
  funcUpdateContentFailed: "No se pudo actualizar el contenido",
  funcAddThemeFailed: "No se pudo agregar el tema",
  funcDeleteThemeFailed: "No se pudo eliminar el tema",
  funcUpdateThemeFailed: "No se pudo actualizar el tema",
  funcAddThemeColorFailed: "No se pudo agregar el color del tema",
  funcDeleteThemeColorFailed: "No se pudo eliminar el color del tema",
  funcUpdateThemeColorFailed: "No se pudo actualizar el color del tema",
  funcAddLanguageFailed: "No se pudo agregar el idioma",
  funcDeleteLanguageFailed: "No se pudo eliminar el idioma",
  funcUpdateLanguageFailed: "No se pudo actualizar el idioma",
  funcAddThemeContentFailed: "No se pudo agregar el contenido del tema",
  funcDeleteThemeContentFailed: "No se pudo eliminar el contenido del tema",
  funcUpdateThemeContentFailed: "No se pudo actualizar el contenido del tema",
  funcAddContentPositionFailed: "No se pudo agregar la posición del contenido",
  funcUpdateContentPositionFailed: "No se pudo actualizar la posición del contenido",
  funcDeleteContentPositionFailed: "No se pudo eliminar la posición del contenido",
  funcAddThemeProviderTypeFailed: "No se pudo agregar el tipo de proveedor de tema",
  funcUpdateThemeProviderTypeFailed: "No se pudo actualizar el tipo de proveedor de temas",
  funcDeleteThemeProviderTypeFailed: "No se pudo eliminar el tipo de proveedor de temas",
  funcAddPackageFailed: "No se pudo agregar el paquete",
  funcUpdatePackageFailed: "No se pudo actualizar el paquete",
  funcDeletePackageFailed: "No se pudo eliminar el paquete",
  nicknameRequired: "Se requiere apodo",
  accountStatusRequired: "Se requiere el estado de la cuenta",
  contentIdMaxLength50: "La longitud máxima del ID del menú es 50",
  positionMaxLength10: "La longitud máxima de la posición es 10",
  contentDescMaxLength200: "La longitud máxima de la descripción del contenido es de 200",
  domainStatusRequired: "Se requiere el estado del dominio",
  funcAddDomainFailed: "No se pudo agregar el dominio",
  funcUpdateDomainFailed: "No se pudo actualizar el dominio",
  uploadFailed: "¡Error de carga!",
  sortKeyMaxLength50: "La longitud máxima de la clave de ordenación es 50",
  invalidSortTypeFormat: "Formato de tipo de ordenación no válido",
  invalidPackageId: "ID de paquete no válido",
  invalidAccountStatusFormat: "Formato de estado de cuenta no válido",
  invalidSiteStatusFormat: "Formato de estado del sitio no válido",
  invalidPackageStatus: "Estado del paquete no válido",
  invalidEmailFormat: "Formato de correo electrónico no válido",
  invalidPhoneFormat: "Formato de teléfono no válido",
  languageLengthNotInRange: "La longitud del idioma no está en el rango (2-5)",
  languageDescriptionMaxLength50: "La longitud máxima de la descripción del idioma es 50",
  remarkMaxLength500: "La longitud máxima de la observación es de 500",
  themeProviderTypeMaxLength50: "La longitud máxima del tipo de proveedor de temas es 50",
  themeNameMaxLength50: "La longitud máxima del nombre del tema es 50",
  themeColorMaxLength20: "La longitud máxima del color del tema es 20",
  noSpace: "No debe contener espacio",
  packageDescEnRequired: "Nombre Inglés es obligatorio",
  packageDescEnMaxLength20: "La longitud máxima del nombre en inglés es de 20",
  allParamsIsNull: "Todos los parámetros son nulos",
  contentCannotBeRemove: "El contenido no se puede eliminar",
  contentDetailsRequired: "Se requieren detalles de contenido",
  domainCannotBeUse: "El dominio no se puede utilizar",
  domainGroupMaxLength20: "La longitud máxima del grupo de dominios es 20,",
  domainGroupRequired: "Se requiere un grupo de dominios",
  domainNameCannotUpdate: "El nombre de dominio no se puede actualizar",
  domainNameMaxLength400: "La longitud máxima del nombre de dominio es 400",
  domainsRequired: "Los dominios son obligatorios",
  domainStatusMaxLength20: "La longitud máxima del estado del dominio es 20",
  domainTypeMaxLength10: "La longitud máxima del tipo de dominio es 10",
  funcAddThemeContentGroupFailed: "Error al agregar un grupo de contenido de tema",
  funcDeleteThemeContentGroupFailed: "Error al eliminar el grupo de contenido del tema",
  funcOpsiteUpdateFailed: "Error en la actualización de Opsite",
  funcResetAccountPasswordFailed: "Error al restablecer la contraseña de la cuenta",
  funcSiteLanguageUpsertFailed: "Error en la actualización del idioma del sitio",
  funcSiteThemeContentUpsertFailed: "Error en la actualización del contenido del tema del sitio",
  funcSiteThemeUpsertFailed: "Error en la actualización del tema del sitio",
  funcSiteUpdateFailed: "Error en la actualización del sitio",
  funcUpdateAccountFailed: "Error en la actualización de la cuenta",
  funcUpdateAccountStatusActiveFailed: "Error al actualizar el estado de la cuenta a activa",
  funcUpdateAccountStatusCompanyBlockFailed: "Error al actualizar el estado de la cuenta al bloque de la empresa",
  funcUpdateAccountStatusSuspendFailed: "Error al actualizar el estado de la cuenta para suspender",
  funcUpdateThemeContentGroupFailed: "Error en la actualización del grupo de contenido del tema",
  invalidBoDomain: "Dominio BO no válido",
  invalidOperatorIdFormat: "Formato de ID de operador no válido",
  invalidOpsite: "Operación no válida",
  invalidOpsiteOperator: "Operador de opsite no válido",
  invalidOpsiteVersion: "Invalid opsite version",
  invalidParentContentInGroup: "Contenido principal no válido en el grupo",
  invalidSite: "Sitio no válido",
  invalidSiteStatus: "Estado del sitio no válido",
  invalidThemeContentGroup: "Grupo de contenido de tema no válido",
  languageCannotBeUse: "El lenguaje no se puede usar",
  languagesRequired: "Los idiomas son obligatorios",
  logo1Required: "Se requiere el logotipo",
  notSupportMultiDefault: "No se admite el uso de valores predeterminados múltiples",
  operatorIdMaxLength50: "La longitud máxima del ID del operador es de 50.",
  opsiteNotMatch: "Opsite no coincide",
  packageTypeMaxLength15: "La longitud máxima del tipo de paquete es 15",
  parentContentIdCannotSameWithContentId: "El ID de contenido principal no puede ser el mismo que el ID de contenido",
  phoneNumberRequired: "Se requiere número de teléfono",
  siteIdRequired: "Se requiere ID del sitio",
  siteNameMaxLength50: "La longitud máxima del nombre del sitio es 50",
  siteNameRequired: "Se requiere el nombre del sitio",
  technicalError: "Error técnico",
  themeCannotBeRemove: "El tema no se puede eliminar",
  themeCodeCannotBeUse: "No se puede utilizar el código del tema",
  themeCodeMaxLength20: "La longitud máxima del código del tema es 20",
  themeColorCannotBeRemove: "El color del tema no se puede eliminar",
  themeColorCannotBeUse: "No se puede utilizar el color del tema",
  themeContentCannotBeUse: "No se puede utilizar el contenido del tema",
  themeContentGroupCannotBeUse: "No se puede utilizar el grupo de contenido del tema",
  themeContentGroupDescriptionMaxLength50: "La longitud máxima de la descripción del grupo de contenido del tema es 50",
  themeContentGroupMaxLength20: "La longitud máxima del grupo de contenido del tema es 20",
  themeContentGroupRequired: "Se requiere el grupo de contenido del tema",
  themeNameCannotBeUse: "No se puede utilizar el nombre del tema",
  userHaventVerifyThisBefore: "El usuario no ha verificado esto antes",
  isDefaultTrueRequired: "El idioma debe tener 1 valor predeterminado",
  accountIdMaxLength50: "La longitud máxima del ID de usuario es 50",
  headBodyScriptEitherOne: "Por favor, introduzca el guión principal o el guión del cuerpo",
  alphaOrNum: "Debe ser alfabeto o números solamente",
  phoneValid: "Por favor, introduzca un número de teléfono válido",
  permittedAmountRequired: "Se requiere la cantidad permitida",
  ignoreRiskRequired: "Es necesario ignorar el riesgo",
  paymentDescRequired: "Se requiere descripción de pago",
  gameTypeRequired: "Se requiere el tipo de juego",
  statusRequired: "El estado es obligatorio",
  payoutIdRequired: "Se requiere un ID de pago",
  commNotExists: "La comisión no existe",
  parentCommNotExists: "La comisión de los padres no existe",
  carryOverNotExists: "El traspaso no existe",
  hotGameExists: "El juego caliente ya existe",
  commSportsExceededParent: "La comisión por deportes excedió a la matriz",
  commSlotsExceededParent: "Comisión por franjas horarias excedidas de la matriz",
  commLivecasinoExceededParent: "La comisión por casino en vivo excedió a la principal",
  commCockfightExceededParent: "La comisión por pelea de gallos excedió a la del padre",
  commOthersExceededParent: "La comisión por otros excedió al padre",
  hotGameNotExists: "El juego caliente no existe",
  noSecurityDeposit: "Sin fondo de garantía",
  exchangeRateNotExists: "El tipo de cambio no existe",
  insufficientSecurityDeposit: "Fondo de garantía insuficiente",
  duplicateDomain: "Dominio duplicado",
  contactEmailNotExists: "El correo electrónico de contacto no existe",
  featuredGameNotExists: "El juego de bonificación no existe",
  newGameNotExists: "El nuevo juego no existe",
  popularGameNotExists: "El juego popular no existe",
  featuredGameExists: "El juego de características ya existe",
  newGameExists: "Ya existe un nuevo juego",
  popularGameExists: "El juego popular ya existe,",
  rebateNotExists: "El descuento no existe",
  riskyMember: "Miembro arriesgado",
  ipRestricted: "IP restringida",
  notSupportedBank: "Banco no admitido.",
  requestTooFrequent: "La solicitud es demasiado frecuente.",
  paymentOptionNotExists: "La opción de pago no existe",
  earningIdRequired: "Se requiere una identificación de obtención.",
  ptOnRequired: "PT activado obligatorio.",
  ptRequired: "Se requiere PT.",
  userIdRequired: "ID de usuario requerido.",
  businessIdRequired: "Se requiere ID de empresa.",
  subAccountIdRequired: "Se requiere ID de subcuenta.",
  sourceAccountIdRequired: "Se requiere ID de cuenta de origen.",
  targetAccountIdRequired: "Se requiere ID de cuenta de destino.",
  ticketTaken: "El boleto está tomado",
  ticketNotTaken: "El boleto no está tomado",
  invalidPt: "PT no válido",
  topupIdRequired: "Se requiere identificación de recarga",
  promotionMemberLogNotExists: "El registro de miembros de la promoción no existe",
  paymentOptionInactive: "Opción de pago inactiva",
  invalidCartStatusFormat: "Formato de estado del carrito no válido",
  requestIncompleted: "Solicitud incompleta",
  unknownError: "Se ha producido un error desconocido",
  cartIdRequired: "Se requiere ID de carrito",
  stepNameRequired: "Se requiere el nombre del paso",
  invalidCart: "Carrito no válido",
  invalidStepName: "Nombre de paso no válido",
  cartHaventSetupComplete: "El carrito no se ha completado la configuración",
  funcCartCreateFailed: "Error al crear el carrito",
  funcCartUpdateFailed: "No se pudo actualizar el carrito",
  funcSiteCreateFailed: "Error al crear el sitio",
  funcCartPurchasedUpdateFailed: "No se pudo actualizar el carrito comprado",
  invalidPasswordFormat: "Formato de contraseña no válido",
  currencyCodeRequired: "Se requiere moneda",
  funcCartLanguageUpsertFailed: "Error en la actualización del lenguaje del carro de funciones",
  invalidUserIdFormat: "Formato de ID de usuario no válido",
  operatorPasswordRequired: "Se requiere contraseña de operador",
  funcCartOperatorInfoUpsertFailed: "Error en la actualización de la información del operador del carro de funciones",
  invalidOperatorPasswordFormat: "Formato de contraseña de operador no válido",
  operatorIdCannotBeUse: "No se puede utilizar el ID de operador",
  siteNameLengthNotInRange: "La longitud del nombre del sitio no está en el rango",
  userIdCannotBeUse: "No se puede utilizar el ID de usuario",
  siteIdAlrdExist: "El ID del sitio ya existe",
  operatorIdAlrdExist: "El ID de operador ya existe",
  externalIdAlrdExist: "El ID externo ya existe",
  opsiteContentAlrdExist: "El contenido del tema del sitio ya existe",
  opsiteLanguageAlrdExist: "El lenguaje del contenido del sitio ya existe",
  boAccountAlrdExist: "La cuenta BO ya existe",
  boAccountProfileAlrdExist: "El perfil de cuenta BO ya existe",
  boAccountLoginAlrdExist: "El inicio de sesión de la cuenta BO ya existe",
  funcCartThemeCodeUpsertFailed: "Error al actualizar el tema del carrito",
  funcCartThemeColorUpsertFailed: "Error al mejorar el color del carrito",
  funcOpsiteCreateFailed: "Error al crear el contenido del sitio",
  alphabetValid: "Debe tener al menos una letra mayúscula y minúscula",
  numberValid: "Debe tener al menos un número",
  symbolValid: "Debe tener al menos un símbolo",
  credentialNotSet: "Credencial no configurada,",
  validBankAccFormat: "Banco inválido Acc No. Formato",
  moreThan: "{fname} debe ser menor o igual que {fname2}",
  lessThan: "{fname} debe ser mayor o igual que {fname2}.",
  bankAccountNotAvailable: "Cuenta bancaria no disponible.",
  insufficientCredit: "Crédito insuficiente",
  enableRequired: "Se requiere habilitar.",
  funcAddGameFailed: "No se pudo agregar el juego.",
  funcAddGameRewardByBatchFailed: "No se pudo agregar la recompensa del juego por lote.",
  funcAddGameRewardFailed: "No se pudo agregar la recompensa del juego.",
  funcAddGameTemplateFailed: "No se pudo agregar la plantilla de juego.",
  funcAddLayoutTemplateFailed: "No se pudo agregar la plantilla de diseño.",
  funcAddOperatorGameFailed: "No se pudo agregar el juego de operador.",
  funcAddOperatorMemberWalletFailed: "No se pudo agregar la billetera del miembro del operador.",
  funcDeleteGameFailed: "No se pudo eliminar el juego.",
  funcDeleteGameRewardFailed: "No se pudo eliminar la recompensa del juego.",
  funcDeleteGameTemplateFailed: "No se pudo eliminar la plantilla del juego.",
  funcDeleteLayoutTemplateFailed: "No se pudo eliminar la plantilla de diseño.",
  funcDeleteOperatorGameFailed: "No se pudo eliminar el juego de operador.",
  funcUpdateGameFailed: "No se pudo actualizar el juego.",
  funcUpdateGameRewardFailed: "No se pudo actualizar la recompensa del juego.",
  funcUpdateGameTemplateFailed: "No se pudo actualizar la plantilla del juego.",
  funcUpdateLayoutTemplateFailed: "No se pudo actualizar la plantilla de diseño.",
  funcUpdateOperatorGameFailed: "No se pudo actualizar el juego del operador.",
  gameCannotBeRemove: "El juego no se puede eliminar.",
  gameNameCannotBeUse: "No se puede usar el nombre del juego.",
  gameNameMaxLength150: "El nombre del juego debe tener como máximo 150 caracteres.",
  gameRewardCannotBeUse: "La recompensa del juego no se puede usar.",
  gameRewardLimitExceeded: "Se ha excedido el límite de recompensas del juego.",
  gameTemplateExist: "La plantilla de juego ya existe.",
  gameTypeMaxLength20: "El tipo de juego debe tener como máximo 20 caracteres.",
  invalidGame: "Juego no válido.",
  invalidGameReward: "Recompensa de juego no válida.",
  invalidGameTemplate: "Plantilla de juego no válida.",
  invalidMemberWallet: "Billetera de miembro no válida.",
  invalidOperatorGame: "Juego de operador no válido.",
  invalidRewardProbability: "Probabilidad de recompensa no válida.",
  invalidTemplate: "Plantilla no válida.",
  maxGameRewardRequired: "Se requiere la máxima recompensa del juego.",
  maxMiniGameRewardRequired: "Se requiere la máxima recompensa del minijuego.",
  memberWalletAlrdExist: "La billetera de miembro ya existe.",
  operatorGameCannotBeUse: "No se puede utilizar el juego de operador.",
  operatorGameIdRequired: "Se requiere el ID del juego del operador.",
  rewardCodeMaxLength20: "El código de recompensa debe tener como máximo 20 caracteres.",
  rewardCodeRequired: "Se requiere un código de recompensa.",
  rewardCurrencyMaxLength5: "La moneda de recompensa debe tener como máximo 5 caracteres.",
  rewardCurrencyRequired: "Se requiere moneda de recompensa.",
  rewardDescriptionMaxLength100: "La descripción de la recompensa debe tener como máximo 100 caracteres.",
  rewardNameMaxLength50: "El nombre de la recompensa debe tener como máximo 50 caracteres.",
  rewardProbabilityRequired: "Se requiere probabilidad de recompensa.",
  rewardRequired: "Se requiere recompensa.",
  selectedTemplateMaxLength30: "La plantilla seleccionada debe tener como máximo 30 caracteres.",
  selectedTemplateRequired: "Se requiere la plantilla seleccionada.",
  success: "Éxito.",
  templateCannotBeRemove: "La plantilla no se puede eliminar.",
  templateCodeCannotBeUse: "No se puede utilizar el código de plantilla.",
  templateCodeMaxLength30: "El código de la plantilla debe tener como máximo 30 caracteres.",
  templateCodeRequired: "Se requiere código de plantilla.",
  templateNameMaxLength50: "El nombre de la plantilla debe tener como máximo 50 caracteres.",
  tokenRequestRequired: "Se requiere una solicitud de token.",
  tokenRequired: "Se requiere token",
  mustMoreThan: "{fname} debe ser mayor que {fvalue}",
  mustMoreThanOrEqual: "{fname} debe ser mayor o igual que {fvalue}",
  tokenInvalid: "La entrada de token no es válida en {key}",
  cashInvalid: "Entrada de efectivo inválida en {key}",
  atLeastOneRequired: "«Se requiere al menos uno»",
  cash1To7Required: "Se requiere efectivo de 1 a 7",
  cash1To6Required: "«Se requiere efectivo de 1 a 6»",
  cash1To5Required: "«Se requiere efectivo de 1 a 5»",
  cash1To4Required: "«Se requiere efectivo de 1 a 4»",
  cash1To3Required: "«Se requiere efectivo de 1 a 3»",
  cash1To2Required: "«Se requiere 1 o 2 efectivos»",
  cash1Required: "Se requiere efectivo 1",
  token1To7Required: "Se requiere el token 1 a 7",
  token1To6Required: "Se requiere el token 1 a 6",
  token1To5Required: "Se requiere el token 1 a 5",
  token1To4Required: "Se requiere el token 1 a 4",
  token1To3Required: "Se requiere el token 1 a 3",
  token1To2Required: "Se requiere la ficha 1 a 2",
  token1Required: "Se requiere el token 1",
  cycleRequired: "Se requiere un ciclo",
  targetAmountRequired: "«Se requiere un importe objetivo»",
  gamifyIdRequired: "Se requiere un ID de recompensa",
  gamifyMemberProcessed: "Recompensa procesada por miembro",
  gamifyNotExists: "La recompensa no existe",
  gamifyInactive: "Recompensa inactivo",
  invalidCycle: "Ciclo no válido",
  memberIdMaxLength50: "El ID de miembro no debe exceder los 50 caracteres",
  funcAddGameWalletFreeCreditFailed: "No se pudo agregar crédito gratuito a la billetera del juego",
  funcUpdateOperatorMemberWalletBalanceFailed: "No se pudo actualizar el saldo de la billetera del miembro del operador",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "No se pudo actualizar el saldo de la billetera del miembro del operador por monto congelado",
  mustHaveBothAlphaNumOnly: "Use solo alfabetos y números, con al menos uno de cada uno.",
  setupGameRewardBeforeEnable: "Por favor, configura la recompensa del juego antes de habilitarla.",
  rewardProbabilityMustNotAllZero: "Las probabilidades de recompensa no deben ser todas cero.",
  totalRewardProbabilityCannotOver100: "La probabilidad total de recompensa no puede exceder de 100.",
  credential1To2Required: "Se requiere credencial 1 a 2.",
  credential1To4Required: "Se requiere credencial 1 a 4.",
  newRemarkRequired: "Es necesario hacer una observación.",

  notSupportedWithdrawalPG: "Pasarela de pago para retiros no compatible.",
};